export const CONTACT_US_LINK: any = {
  ar: 'https://www.sahamassurance.ma/ar/contact',
  fr: 'https://www.sahamassurance.ma/contact',
};

export const RECLAMATION_LINK: any = {
  ar: 'https://www.sahamassurance.ma/ar/contact?subject=reclamation',
  fr: 'https://www.sahamassurance.ma/contact?subject=reclamation',
};

export const PREVENTION_AUTO_LINK: any = {
  ar:
    'https://www.sahamassurance.ma/sites/default/files/guide_de_prevention_auto.pdf',
  fr:
    'https://www.sahamassurance.ma/sites/default/files/guide_de_prevention_auto.pdf',
};

export const PREVENTION_MRH_LINK: any = {
  ar: 'https://www.sahamassurance.ma/ar/prevention-habitation',
  fr: 'https://www.sahamassurance.ma/prevention-habitation',
};

export const PRODUCT_ASSUR_AUTO_RABEH_LINK: any = {
  ar: 'https://www.sahamassurance.ma/ar/produit/assur-auto-Rabe7',
  fr: 'https://www.sahamassurance.ma/produit/assur-auto-Rabe7',
};

export const PRODUCT_WAQET_OU_ZMANE_LINK: any = {
  ar: 'https://www.sahamassurance.ma/ar/produit/waqet-ou-zmane-damane',
  fr: 'https://www.sahamassurance.ma/produit/waqet-ou-zmane-damane',
};

export const YOUTUBE_LINK: string =
  'https://www.youtube.com/user/SahamAssuranceMaroc';
export const FACEBOOK_LINK: string =
  'https://web.facebook.com/sahamassurancemaroc/?_rdc=1&_rdr';

export const MRH_QUOTE_LINK: any = {
  ar: 'https://sahamassurance.ma/ar/simulateur-habitation',
  fr: 'https://sahamassurance.ma/simulateur-habitation',
};

export const EPARGN_PRODUCT_LINK: any = {
  ar: 'https://sahamassurance.ma/ar/produit/epargne',
  fr: ' https://sahamassurance.ma/produit/epargne',
};
